// extracted by mini-css-extract-plugin
export default {"wrapper":"bvQ10wRfoKpKR54JAvRL","titleSubtitleWrapper":"HT4vNcpFWZ7JSQ535I1H","title":"frrlHuI_ZK9qYANCKBr8","subtitle":"jFdNqlqdTL6b3fTJPXu5","content":"dGxGRXGwn8sV2PK52WUX"};